export default __webpack_public_path__ + "static/media/slide8.9fdac74d.png";